export enum FeaturePermissions {
  //* Company based features - value must be the same as the key of the flag in company details data
  ACCOUNTING_ID = 'enable_accounting_id',
  ADVANCED_ACCOUNTING = 'advanced_accounting',
  REQUIRE_APPROVAL_FOR_PAYMENT = 'require_approval_for_payments',
  VAT_PERIOD = 'enable_vat_period',
}
